class Controller {
  constructor($mdDialog, $state, $injector, corporateId) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.$state = $state;
    this.Events = $injector.get("Events");
    this.CorporateResource = $injector.get("Corporate");
    this.corporateId = corporateId;
    this.successEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.corporateAdmin = {};
  }

  createCorporateAdmin() {
    const regionCode = document.querySelector("#country").value;
    this.CorporateResource.createCorporateAdmin(this.corporateId, {
      ...this.corporateAdmin,
      region_code: regionCode,
      looker_group_ids: this.corporateAdmin.looker_group_ids
        ? this.corporateAdmin.looker_group_ids
            .split(",")
            .map((num) => parseInt(num, 10))
        : undefined,
    }).$promise.then(
      () => {
        this.Events.emit(this.successEvent, {
          message: "New corporate admin added successfully",
        });
        this.$mdDialog.hide();
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.createCorporateAdmin();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/corporateAdminDialog/createCorporateAdmin.js